import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateAccountComponent } from '../create-account/create-account.component';

@Component({
  selector: 's18-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  carouselBanner: any;

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.carouselBanner = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 500,
      interval: { timing: 10000 },
      point: {
        visible: true
      },
      load: 2,
      loop: true,
      touch: true
    }
  }


  startNow() {
    this.dialog.open(CreateAccountComponent, { width: '500px' });
  }

}
